const LOCALITIES = ["metro", "urban", "suburban", "rural"];
const TIERS = ["high", "standard", "low"];

export const transformPricingResponse = (apiResponse) => {
  const responseData = apiResponse?.data ?? apiResponse;

  return {
    pricingModel: responseData.pricingModel,
    baseFeesModel: transformBaseFees(responseData.baseFees),
    demandMultipliers: transformDemandMultipliers(responseData.demandMultipliers),
    directValues: transformDirectValues(responseData.directValues),
    overrides: responseData.overrides || [],
    lastChanges: transformAuditLog(responseData.auditLog),
  };
};

const transformBaseFees = (baseFees) => {
  if (!baseFees) return createEmptyBaseFees();
  return {
    metro: baseFees.metro || 0,
    urban: baseFees.urban || 0,
    suburban: baseFees.suburban || 0,
    rural: baseFees.rural || 0,
  };
};

const transformDemandMultipliers = (multipliers) => {
  if (!multipliers) return createEmptyDemandMultipliers();
  return {
    high: multipliers.high ?? 1.5,
    standard: multipliers.standard ?? 1.0,
    low: multipliers.low ?? 0.6,
  };
};

const transformDirectValues = (directValuesObj) => {
  if (!directValuesObj) return createEmptyDirectValues();

  return {
    joiningFee: transformPriceTypeNewFormat(directValuesObj.joiningFee),
    proMonthly: transformPriceTypeNewFormat(directValuesObj.proMonthly),
    premiumMonthly: transformPriceTypeNewFormat(directValuesObj.premiumMonthly),
    featuredWeekly: transformPriceTypeNewFormat(directValuesObj.featuredWeekly),
  };
};

const transformPriceTypeNewFormat = (priceTypeObj) => {
  if (!priceTypeObj) {
    return createEmptyPriceTypeStructure();
  }

  return {
    metro: {
      high: priceTypeObj.high?.metro || 0,
      standard: priceTypeObj.standard?.metro || 0,
      low: priceTypeObj.low?.metro || 0,
    },
    urban: {
      high: priceTypeObj.high?.urban || 0,
      standard: priceTypeObj.standard?.urban || 0,
      low: priceTypeObj.low?.urban || 0,
    },
    suburban: {
      high: priceTypeObj.high?.suburban || 0,
      standard: priceTypeObj.standard?.suburban || 0,
      low: priceTypeObj.low?.suburban || 0,
    },
    rural: {
      high: priceTypeObj.high?.rural || 0,
      standard: priceTypeObj.standard?.rural || 0,
      low: priceTypeObj.low?.rural || 0,
    },
  };
};

const transformAuditLog = (auditLog) => {
  if (!auditLog) return [];

  return auditLog.map((entry) => ({
    id: entry.id,
    action: entry.changeType,
    changeType: entry.changeType,
    oldValues: parseJsonSafely(entry.oldValues),
    newValues: parseJsonSafely(entry.newValues),
    changedByAdminId: entry.adminId,
    changedAt: entry.timestamp,
    timestamp: entry.timestamp,
    details: {
      oldValues: parseJsonSafely(entry.oldValues),
      newValues: parseJsonSafely(entry.newValues),
    },
  }));
};

const parseJsonSafely = (jsonString) => {
  try {
    return typeof jsonString === "string" ? JSON.parse(jsonString) : jsonString;
  } catch {
    return jsonString;
  }
};

export const createEmptyDirectValues = () => ({
  joiningFee: createEmptyPriceTypeStructure(),
  proMonthly: createEmptyPriceTypeStructure(),
  premiumMonthly: createEmptyPriceTypeStructure(),
  featuredWeekly: createEmptyPriceTypeStructure(),
});

export const createEmptyPriceTypeStructure = () => ({
  metro: { high: 0, standard: 0, low: 0 },
  urban: { high: 0, standard: 0, low: 0 },
  suburban: { high: 0, standard: 0, low: 0 },
  rural: { high: 0, standard: 0, low: 0 },
});

export const createEmptyBaseFees = () => ({
  metro: 0,
  urban: 0,
  suburban: 0,
  rural: 0,
});

export const createEmptyDemandMultipliers = () => ({
  high: 1.5,
  standard: 1.0,
  low: 0.6,
});
